module.exports = __webpack_public_path__ + "static/media/logo.7cd714d7.png";